/**
 * AnyGift LIP補完：/cart/add.js のfetchを自動インターセプト
 */
(function() {
  const ORIGINAL_FETCH = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.includes('/cart/add.js') && options && options.body) {
      try {
        const form = document.querySelector('form[action^="/cart/add"]');
        if (form) {
          const propInputs = form.querySelectorAll('input[name^="properties["]');
          if (propInputs.length > 0) {
            const props = {};
            propInputs.forEach(function(input) {
              const match = input.name.match(/^properties\[(.+)\]$/);
              if (match && match[1]) {
                if (input.type === 'checkbox' && !input.checked) return;
                props[match[1]] = input.value;
              }
            });
            if (Object.keys(props).length > 0) {
              const body = JSON.parse(options.body);
              if (body.items) {
                body.items = body.items.map(function(item) {
                  return { ...item, properties: { ...(item.properties || {}), ...props } };
                });
              } else {
                body.properties = { ...(body.properties || {}), ...props };
              }
              options.body = JSON.stringify(body);
            }
          }
        }
      } catch(e) {
        // 通常のカート追加を妨げないよう静かに失敗
      }
    }
    return ORIGINAL_FETCH.apply(this, arguments);
  };
})();



// footer accordion
if (window.matchMedia("(max-width: 760px)")) {
  document.addEventListener("DOMContentLoaded", () => {
    const linkTitle = document.querySelectorAll(".link-title");
    for (let i = 0; i < linkTitle.length; i++) {
      let titleEach = linkTitle[i];
      titleEach.addEventListener("click", () => {
        titleEach.classList.toggle("active");
      });
    }
  });
}

// Home Collections
const mediaQuery = window.matchMedia("(min-width: 641px)");
const createHomeCollectionCarousel = function (
  rootEl,
  carouselSelector,
  carouselBtnPrevSelector,
  carouselBtnNextSelector
) {
  const homeCollectionCarouselElement = rootEl.querySelector(carouselSelector);
  if (!homeCollectionCarouselElement) {
    return;
  }

  let homeCollectionCarousel = new Flickity(homeCollectionCarouselElement, {
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    contain: true,
    resize: true,
    cellAlign: "center",
    groupCells: 4,
  });

  // mobile init
  if (!mediaQuery.matches) {
    homeCollectionCarousel.destroy();
  }

  /*
  Buttons
   */
  const carouselPrevBtnPc = rootEl.querySelector(carouselBtnPrevSelector);
  const carouselNextBtnPc = rootEl.querySelector(carouselBtnNextSelector);

  /*
  Resize
   */
  let resizeFlag = 500;
  let timeoutID = 0;
  window.addEventListener("resize", () => {
    resizeFlag = 500;
    clearTimeout(timeoutID);

    timeoutID = setTimeout(() => {
      homeCollectionCarousel.destroy();
      if (!mediaQuery.matches) {
        return;
      }
      homeCollectionCarousel = new Flickity(homeCollectionCarouselElement, {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        contain: true,
        resize: true,
        cellAlign: "center",
        groupCells: 4,
      });

      if (carouselPrevBtnPc) carouselPrevBtnPc.style.visibility = "hidden";
      if (carouselNextBtnPc) carouselNextBtnPc.style.visibility = "visible";

      homeCollectionCarousel.on("select", function () {
        const index = homeCollectionCarousel.selectedIndex;
        if (!carouselPrevBtnPc || !carouselNextBtnPc) return;
        if (index === 0) {
          carouselPrevBtnPc.style.visibility = "hidden";
        } else {
          carouselPrevBtnPc.style.visibility = "visible";
        }
        if (index === homeCollectionCarousel.slides.length - 1) {
          carouselNextBtnPc.style.visibility = "hidden";
        } else {
          carouselNextBtnPc.style.visibility = "visible";
        }
      });
    }, resizeFlag);
  });

  if (carouselPrevBtnPc) {
    carouselPrevBtnPc.addEventListener("click", function () {
      homeCollectionCarousel.previous();
    });
  }
  if (carouselNextBtnPc) {
    carouselNextBtnPc.addEventListener("click", function () {
      homeCollectionCarousel.next();
    });
  }

  /*
  Events
   */
  // Initial visibility
  if (carouselNextBtnPc && homeCollectionCarousel.slides.length <= 1) {
    carouselNextBtnPc.style.visibility = "hidden";
  }
  homeCollectionCarousel.on("select", function () {
    const index = homeCollectionCarousel.selectedIndex;
    if (!carouselPrevBtnPc || !carouselNextBtnPc) return;
    if (index === 0) {
      carouselPrevBtnPc.style.visibility = "hidden";
    } else {
      carouselPrevBtnPc.style.visibility = "visible";
    }
    if (index === homeCollectionCarousel.slides.length - 1) {
      carouselNextBtnPc.style.visibility = "hidden";
    } else {
      carouselNextBtnPc.style.visibility = "visible";
    }
  });
};

/* 2026/05/29 design update: layout handled by CSS grid/scroll, Flickity disabled for home-collection-products */
const homeCollectionCarouselRoots = [];
homeCollectionCarouselRoots.forEach((rootEl) => {
  try {
    createHomeCollectionCarousel(
      rootEl,
      ".home-collection-products-carousel",
      ".home-collection-products-carousel-button.Previous",
      ".home-collection-products-carousel-button.Next"
    );
  } catch (e) {
    console.warn("home-collection carousel init failed", e);
  }
});

// Home News
const createHomeNewsCarousel = () => {
  const homeNewsCarouselElement = document.querySelector(".home-news-articles");
  if (homeNewsCarouselElement) {
    let homeNewsCarousel = new Flickity(homeNewsCarouselElement, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      contain: true,
      cellAlign: "left",
    });

    let resizeFlag = 500;
    let timeoutID = 0;
    window.addEventListener("resize", () => {
      resizeFlag = 500;
      clearTimeout(timeoutID);

      timeoutID = setTimeout(() => {
        homeNewsCarousel.destroy();
        homeNewsCarousel = new Flickity(homeNewsCarouselElement, {
          prevNextButtons: false,
          pageDots: false,
          wrapAround: false,
          contain: true,
          cellAlign: "left",
        });

        // button reset
        prevBtnPc.style.visibility = "hidden";
        prevBtnSp.style.opacity = "0.6";
        prevBtnSp.setAttribute("disabled", "true");
        nextBtnPc.style.visibility = "visible";
        nextBtnSp.style.opacity = "1";
        nextBtnSp.removeAttribute("disabled");

        homeNewsCarousel.on("select", function () {
          let index = homeNewsCarousel.selectedIndex;
          if (index === 0) {
            prevBtnPc.style.visibility = "hidden";
            prevBtnSp.style.opacity = "0.6";
            prevBtnSp.setAttribute("disabled", "true");
          } else {
            prevBtnPc.style.visibility = "visible";
            prevBtnSp.style.opacity = "1";
            prevBtnSp.removeAttribute("disabled");
          }
          if (index === homeNewsCarousel.slides.length - 1) {
            nextBtnPc.style.visibility = "hidden";
            nextBtnSp.style.opacity = "0.6";
            nextBtnSp.setAttribute("disabled", "true");
          } else {
            nextBtnPc.style.visibility = "visible";
            nextBtnSp.style.opacity = "1";
            nextBtnSp.removeAttribute("disabled");
          }
        });
      }, resizeFlag);
    });

    /*
    Buttons
     */
    const prevBtnPc = document.querySelector(".home-news-carousel-button.Pc.Previous");
    const nextBtnPc = document.querySelector(".home-news-carousel-button.Pc.Next");
    const prevBtnSp = document.querySelector(".home-news-carousel-button.Sp.Previous");
    const nextBtnSp = document.querySelector(".home-news-carousel-button.Sp.Next");
    prevBtnPc.addEventListener("click", function () {
      homeNewsCarousel.previous();
    });
    nextBtnPc.addEventListener("click", function () {
      homeNewsCarousel.next();
    });
    prevBtnSp.addEventListener("click", function () {
      homeNewsCarousel.previous();
    });
    nextBtnSp.addEventListener("click", function () {
      homeNewsCarousel.next();
    });

    /*
    Events
     */
    homeNewsCarousel.on("select", function () {
      let index = homeNewsCarousel.selectedIndex;
      if (index === 0) {
        prevBtnPc.style.visibility = "hidden";
        prevBtnSp.style.opacity = "0.6";
        prevBtnSp.setAttribute("disabled", "true");
      } else {
        prevBtnPc.style.visibility = "visible";
        prevBtnSp.style.opacity = "1";
        prevBtnSp.removeAttribute("disabled");
      }
      if (index === homeNewsCarousel.slides.length - 1) {
        nextBtnPc.style.visibility = "hidden";
        nextBtnSp.style.opacity = "0.6";
        nextBtnSp.setAttribute("disabled", "true");
      } else {
        nextBtnPc.style.visibility = "visible";
        nextBtnSp.style.opacity = "1";
        nextBtnSp.removeAttribute("disabled");
      }
    });
  }
};
createHomeNewsCarousel();

// Flickity
const rsCarousel = document.getElementById("rs-carousel");
if (rsCarousel) {
  const flkty = new Flickity(rsCarousel, {
    cellAlign: "left",
    pageDots: false,
    contain: true,
    arrowShape: {
      x0: 30,
      x1: 60,
      y1: 30,
      x2: 65,
      y2: 30,
      x3: 35,
    },
  });
}

const body = document.querySelector("body");
const zoomFrame = document.createElement("div");
zoomFrame.setAttribute("class", "zoom-frame");
const zoomImg = document.createElement("img");
const zoomClose = document.createElement("button");
zoomClose.classList.add("RoundButton");
zoomClose.insertAdjacentHTML(
  "afterbegin",
  `<svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg>`
);
zoomFrame.appendChild(zoomImg);
zoomFrame.appendChild(zoomClose);
body.appendChild(zoomFrame);
const zoomTarget = document.querySelectorAll(".rs-carousel-img");
Array.from(zoomTarget).forEach((b) => {
  b.addEventListener("click", (e) => {
    zoomImg.src = e.target.getAttribute("src");
    zoomFrame.classList.add("active");
  });
});

zoomClose.addEventListener("click", () => {
  zoomFrame.classList.remove("active");
});

// サブスク
let items = [];
const quantityTexts = Array.from(document.querySelectorAll(".quantity-text"));
const quantityButtons = Array.from(document.querySelectorAll(".quantity-button"));
const cartUpdate = document.getElementById("cartUpdate");
const cartDisaboled = document.getElementById("cartDisaboled");
const radioInputs = Array.from(document.querySelectorAll(".selling_plan"));
if (radioInputs[0]) radioInputs[0].checked = true; // ini

const findCheckedRadio = () => radioInputs.find((radio) => radio.checked);

const setQuantityText = (id, quantity) => {
  quantityTexts.forEach((text) => {
    if (text.getAttribute("variant_id") === id) text.textContent = quantity;
  });
  quantityButtons.forEach((button) => {
    if (button.getAttribute("variant_id") === id) button.setAttribute("quantity", quantity);
  });
};

const updateItems = (action, newItem) => {
  switch (action) {
    case "add":
      if (items.find((item) => item.id === newItem.id)) {
        items.forEach((item) => {
          const quantity = Number(item.quantity) + 1;
          if (item.id === newItem.id) {
            item.quantity = quantity;
            setQuantityText(newItem.id, item.quantity);
          }
        });
      } else {
        newItem.quantity = 1;
        items.push(newItem);
        setQuantityText(newItem.id, newItem.quantity);
      }
      break;

    case "decrease":
      if (items.find((item) => item.id === newItem.id)) {
        items.forEach((item, index) => {
          const quantity = Number(item.quantity) - 1;
          if (item.id === newItem.id) {
            if (quantity <= 0) {
              items.splice(index, 1);
              setQuantityText(newItem.id, 0);
            } else {
              item.quantity = quantity;
              setQuantityText(newItem.id, item.quantity);
            }
          }
        });
      }
      break;
    default:
      break;
  }

  checkForm();
};

quantityButtons.forEach((button) => {
  const type = button.getAttribute("data-action");
  const item = {
    id: button.getAttribute("variant_id"),
    quantity: 2,
  };

  button.addEventListener("click", (e) => {
    e.preventDefault();
    if (type === "add") {
      updateItems("add", item);
    }
    if (type === "decrease") {
      updateItems("decrease", item);
    }
  });
});

if (cartUpdate) {
  cartUpdate.addEventListener("click", (e) => {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    const sellingPlancheckedInput = findCheckedRadio();
    const sellingPlanAddedItems = items.map((item) => ({ ...item, selling_plan: sellingPlancheckedInput.value }));

    console.log(sellingPlanAddedItems);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items: sellingPlanAddedItems }),
    })
      .then((response) => {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {},
          })
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
}

const checkForm = () => {
  let allQuantity = 0;
  items.forEach((item) => {
    allQuantity += item.quantity;
  });
  const length = allQuantity < 1 ? true : false;
  cartUpdate.setAttribute("data-show", !length);
  cartDisaboled.setAttribute("data-show", length);
};

function remove() {
  const cartSubscription = Array.from(document.querySelectorAll(".cartSubscription"));
  document.dispatchEvent(new CustomEvent("theme:loading:start"));
  (async () => {
    for (let i = 0; i < cartSubscription.length; i++) {
      const line = cartSubscription[i].value - i;

      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          line: line,
          quantity: 0,
        }),
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
    document.dispatchEvent(new CustomEvent("theme:loading:end"));
    document.dispatchEvent(
      new CustomEvent("product:added", {
        bubbles: true,
        detail: {},
      })
    );
  })();
}

// Product background color on product detail pages
(function () {
  var BG_HANDLES = ["m-ac-02-0700", "m-ac-01-0700", "m-ac-02-0886", "m-ac-01-0886"];
  var BG_COLOR = "#cdcdcd";
  var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!pathMatch || BG_HANDLES.indexOf(pathMatch[1]) === -1) return;

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".Product__SlideItem .AspectRatio, .Product__SlideshowNavImage").forEach(function (el) {
      el.style.backgroundColor = BG_COLOR;
    });
  });
})();

// Wrap ¥ symbols in price elements with .yen span for 1pt size reduction
(function () {
  function wrapYenInPrices(root) {
    const container = root || document.body;
    const walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node.textContent.includes("¥")) return NodeFilter.FILTER_SKIP;
          if (node.parentElement && node.parentElement.classList.contains("yen"))
            return NodeFilter.FILTER_SKIP;
          if (
            node.parentElement &&
            node.parentElement.closest(
              ".Price, .ProductMeta__PriceList, .ProductItem__PriceList, .CartItem__PriceList, .CartItem__LinePriceList, .VariantSelector__ChoicePrice, #cart-total-price"
            )
          ) {
            return NodeFilter.FILTER_ACCEPT;
          }
          return NodeFilter.FILTER_SKIP;
        },
      }
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(function (node) {
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(¥)/).forEach(function (part) {
        if (part === "¥") {
          const span = document.createElement("span");
          span.className = "yen";
          span.textContent = "¥";
          fragment.appendChild(span);
        } else {
          fragment.appendChild(document.createTextNode(part));
        }
      });
      node.parentNode.replaceChild(fragment, node);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    wrapYenInPrices();
  });

  document.addEventListener("cart:updated", function () {
    wrapYenInPrices();
  });
  document.addEventListener("product:added", function () {
    wrapYenInPrices();
  });
})();

/* ========================================
   Language / Country selector modal
   ======================================== */
(function () {
  var closeTimer = null;

  function getModal() {
    return document.querySelector("[data-lang-country-modal]");
  }

  function open() {
    var modal = getModal();
    if (!modal) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    modal.hidden = false;
    document.body.style.overflow = "hidden";
    requestAnimationFrame(function () {
      modal.classList.add("is-open");
    });
  }

  function close() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove("is-open");
    document.body.style.overflow = "";
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      modal.hidden = true;
      closeTimer = null;
    }, 300);
  }

  // Expose for inline onclick handlers on triggers (more reliable on iOS than delegation)
  window.__openLangCountry = function () {
    var openDrawer = document.querySelector('.Drawer[aria-hidden="false"]');
    if (openDrawer) {
      var closeBtn = openDrawer.querySelector('[data-action="close-drawer"]');
      if (closeBtn) closeBtn.click();
      setTimeout(open, 50);
    } else {
      open();
    }
  };

  document.addEventListener("click", function (e) {
    var opener = e.target.closest && e.target.closest("[data-lang-country-open]");
    if (opener) {
      e.preventDefault();
      e.stopPropagation();
      // Close any open Drawer (sidebar menu / cart) first so the modal isn't hidden by it
      var openDrawer = document.querySelector('.Drawer[aria-hidden="false"]');
      if (openDrawer) {
        var closeBtn = openDrawer.querySelector('[data-action="close-drawer"]');
        if (closeBtn) closeBtn.click();
      }
      // Open modal on next tick so drawer close transitions get out of the way
      setTimeout(open, 50);
      return;
    }
    var closer = e.target.closest && e.target.closest("[data-lang-country-close]");
    if (closer) {
      var modal = getModal();
      if (modal && modal.contains(closer)) {
        e.preventDefault();
        close();
      }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var modal = getModal();
    if (modal && !modal.hidden) close();
  });
})();


/* 2026/06 design update: arrow navigation for home-collection scroll carousels */
(function () {
  function initHcpArrows() {
    document.querySelectorAll('.home-collection-products--scroll').forEach(function (sec) {
      var car = sec.querySelector('.home-collection-products-carousel');
      if (!car || car.dataset.hcpArrowsBound) return;
      car.dataset.hcpArrowsBound = '1';
      var prev = sec.querySelector('[data-hcp-prev]');
      var next = sec.querySelector('[data-hcp-next]');
      function page() { return Math.max(car.clientWidth - 8, 100); }
      function update() {
        var atStart = car.scrollLeft <= 4;
        var atEnd = car.scrollLeft + car.clientWidth >= car.scrollWidth - 4;
        if (prev) { prev.style.opacity = atStart ? '0' : '1'; prev.style.pointerEvents = atStart ? 'none' : 'auto'; }
        if (next) { next.style.opacity = atEnd ? '0' : '1'; next.style.pointerEvents = atEnd ? 'none' : 'auto'; }
      }
      if (next) next.addEventListener('click', function () { car.scrollBy({ left: page(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { car.scrollBy({ left: -page(), behavior: 'smooth' }); });
      car.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          window.scrollBy(0, e.deltaY);
          e.preventDefault();
        }
      }, { passive: false });
      car.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHcpArrows);
  } else {
    initHcpArrows();
  }
})();

/* ============================================================
   2026-06-25 — セール旧価格(dmixer-original-price)の取り消し線を「数字だけ」にする。
   ¥(.yen)には線を入れない。dmixerはflex+インラインstyleでline-throughするためCSS単独では¥を除外できない
   →数字テキストノードを <span class="dmx-num"> で包み、CSS側で親=線なし/.dmx-num=line-through。
   ============================================================ */
(function () {
  function wrap(scope) {
    var els = (scope || document).querySelectorAll('.dmixer-original-price');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.querySelector('.dmx-num')) continue; // 既にラップ済み
      var nodes = Array.prototype.slice.call(el.childNodes);
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType === 3 && /[0-9]/.test(n.textContent)) {
          var s = document.createElement('span');
          s.className = 'dmx-num';
          s.textContent = n.textContent;
          el.replaceChild(s, n);
        }
      }
    }
  }
  function run() { try { wrap(document); } catch (e) {} }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  var moTimer = null;
  var mo = new MutationObserver(function () {
    // 2026-09-15: カートドロワー等の大量DOM差し替え時に連続発火してメインスレッドを塞ぎ、
    // ドロワーの開くアニメーションがカクつく原因になっていたためデバウンス化。
    if (moTimer) return;
    moTimer = setTimeout(function () { moTimer = null; run(); }, 150);
  });
  try { mo.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  setTimeout(run, 1000); setTimeout(run, 2500); setTimeout(run, 5000);
})();


/* ============================================================
   2026/09/03 — 商品一覧カード: モバイルでスワイプして2枚目の画像を見れるように
   .ProductItem__ImageWrapper--withAlternateImage 上での横スワイプを検出し、
   is-swipeReady(初回タッチで2枚目を読み込み許可)/is-swiped(2枚目を表示)を切り替える。
   スワイプした場合は直後のクリック(=商品ページ遷移)をキャンセルする。
   ============================================================ */
(function () {
  var THRESHOLD = 24; // px、これ以上の横移動でスワイプとみなす
  var startX = 0, startY = 0, activeCard = null, horizontal = false, didSwipe = false;

  function findCard(target) {
    return target.closest ? target.closest('.ProductItem__ImageWrapper--withAlternateImage') : null;
  }

  // カードが横スクロールコンテナ(新着カルーセル等)の中にある場合はスワイプ画像切替を無効化し、
  // 横スクロール自体を優先する(2026/09/03 修正: ホームの新着カルーセルで横スクロールできなくなっていた不具合対応)
  function isInsideHorizontalScroller(el) {
    var node = el.parentElement;
    for (var i = 0; i < 10 && node && node !== document.body; i++) {
      if (node.scrollWidth > node.clientWidth + 1) {
        var ov = getComputedStyle(node).overflowX;
        if (ov === 'auto' || ov === 'scroll') return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  document.addEventListener('touchstart', function (e) {
    if (e.target.closest('.ProductItem__QuickAddTrigger')) return;
    var card = findCard(e.target);
    if (!card) return;
    if (isInsideHorizontalScroller(card)) return; // 横スクロールカルーセル内では何もしない(ネイティブスクロールに任せる)
    activeCard = card;
    horizontal = false;
    didSwipe = false;
    var t = e.touches[0];
    startX = t.clientX; startY = t.clientY;
    card.classList.add('is-swipeReady'); // 2枚目の遅延読み込みをその場で許可
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!activeCard) return;
    var t = e.touches[0];
    var dx = t.clientX - startX, dy = t.clientY - startY;
    if (!horizontal) {
      if (Math.abs(dx) < 10) return; // まだ判定できない
      if (Math.abs(dx) <= Math.abs(dy)) { activeCard = null; return; } // 縦スクロール優先、以降は何もしない
      horizontal = true;
    }
    e.preventDefault(); // 横スワイプ確定後のみページの縦スクロールを止める
    didSwipe = true;
    if (dx <= -THRESHOLD) activeCard.classList.add('is-swiped');
    else if (dx >= THRESHOLD) activeCard.classList.remove('is-swiped');
  }, { passive: false });

  document.addEventListener('touchend', function () {
    if (activeCard && didSwipe) {
      var card = activeCard;
      var suppressClick = function (ev) { ev.preventDefault(); ev.stopPropagation(); card.removeEventListener('click', suppressClick, true); };
      card.addEventListener('click', suppressClick, true);
    }
    activeCard = null; horizontal = false; didSwipe = false;
  }, { passive: true });
})();


/* === AMPチケットアプリ: ヘッダー導線 (2026-09-18) ==============================
   アプリが body に差し込むトリガー(.ticket-app-coupon-ticket-app-pc / -sp)を検出したら
   ヘッダーの[data-ticket-entry]を表示し、クリックでそのトリガーを叩いてモーダルを開く。
   アプリ埋め込みがOFFの期間はトリガーが無い=ヘッダーにも何も出ない(イベント期間だけONの運用に自動追従)。
   クラス名が将来変わった場合はApp Proxyのチケット一覧へ遷移するフォールバックで最低限つながる。 */
(function () {
  var TRIGGER_SELECTOR = '.ticket-app-coupon-ticket-app-pc, .ticket-app-coupon-ticket-app-sp';
  var FALLBACK_URL = '/apps/amp-ticket/storefront/tickets/';

  function entries() { return document.querySelectorAll('[data-ticket-entry]'); }
  function trigger() { return document.querySelector(TRIGGER_SELECTOR); }

  function reveal() {
    var t = trigger();
    if (!t) return false;
    var list = entries();
    for (var i = 0; i < list.length; i++) list[i].removeAttribute('hidden');
    return list.length > 0;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ticket-entry]') : null;
    if (!btn) return;
    e.preventDefault();
    var t = trigger();
    if (t) { t.click(); } else { window.location.href = FALLBACK_URL; }
  });

  // アプリのJSはdeferで後から描画するため、出現を監視する(最大60秒で打ち切り)。
  if (reveal()) return;
  var mo = new MutationObserver(function () { if (reveal()) { mo.disconnect(); clearTimeout(stop); } });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  var stop = setTimeout(function () { mo.disconnect(); }, 60000);
})();
